<template>
  <ValidationObserver v-slot="{ handleSubmit, valid }">
    <b-form @submit.prevent="handleSubmit(onSubmit)" ref="form" @input="hasInput">
      <b-row>
        <b-col md="6">
          <ValidationProvider rules="required" name="companyName" v-slot="{valid, errors }">
            <b-form-group id="company-name-group">
              <label class="font-weight-500" for="companyName">Firmenname <span style="color: red;">*</span></label>
              <b-form-input :state="errors[0] ? false : (valid ? true : null)" id="companyName" v-model="profile.companyName"
                            type="text"></b-form-input>
              <span class="er">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col offset-md="6"></b-col>
        <b-col md="6">
          <ValidationProvider rules="required" name="firstName" v-slot="{valid, errors }">
            <b-form-group id="company-name-group">
              <label class="font-weight-500" for="first-name">Vorname <span style="color: red;">*</span></label>
              <b-form-input :state="errors[0] ? false : (valid ? true : null)" id="firstName" v-model="profile.firstName"
                            type="text"></b-form-input>
              <span class="er">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col md="6">
          <ValidationProvider rules="required" name="lastName" v-slot="{valid, errors }">
            <b-form-group id="company-name-group">
              <label class="font-weight-500" for="lastName">Nachname <span style="color: red;">*</span></label>
              <b-form-input :state="errors[0] ? false : (valid ? true : null)" id="lastName" v-model="profile.lastName"
                            type="text"></b-form-input>
              <span class="er">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col md="6">
          <ValidationProvider rules="required" name="phoneNumber" v-slot="{valid, errors }">
            <b-form-group id="phone-group">
              <label class="font-weight-500" for="phoneNumber">Telefonnummer <span style="color: red;">*</span></label>
              <b-form-input :state="errors[0] ? false : (valid ? true : null)" id="phoneNumber" v-model="profile.phoneNumber"
                            type="text"></b-form-input>
              <span class="er">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col md="6">
          <ValidationProvider rules="required|email" name="E-Mail" v-slot="{ valid, errors }">
            <b-form-group id="email-group" description="Dokumente wie Bestellungen werden an diese Mailadresse gesendet.">
              <label class="font-weight-500" for="invoiceEmail">E-Mail <span style="color: red;">*</span></label>
              <b-form-input :state="errors[0] ? false : (valid ? true : null)" id="invoiceEmail" v-model="profile.invoiceEmail"
                            type="email"></b-form-input>
              <span class="er">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col offset-md="6"></b-col>
        <b-col md="6">
          <ValidationProvider rules="required" name="street" v-slot="{valid, errors }">
            <b-form-group id="street-group">
              <label class="font-weight-500" for="street">Straße und Hausnummer<span style="color: red;">*</span></label>
              <b-form-input :state="errors[0] ? false : (valid ? true : null)" id="street" v-model="profile.street"
                            type="text"></b-form-input>
              <span class="er">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col offset-md="6"></b-col>
      </b-row>
      <b-row>
        <b-col md="2">
          <ValidationProvider rules="required|numeric" name="PLZ" v-slot="{valid, errors }">
            <b-form-group id="city-group">
              <label class="font-weight-500" for="zip">Postleitzahl<span style="color: red;">*</span></label>
              <b-form-input :state="errors[0] ? false : (valid ? true : null)" id="zip" v-model="profile.zip"
                            type="text"></b-form-input>
              <span class="er">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col md="4">
          <ValidationProvider rules="required" name="city" v-slot="{valid, errors }">
            <b-form-group id="city-group">
              <label class="font-weight-500" for="city">Ort<span style="color: red;">*</span></label>
              <b-form-input :state="errors[0] ? false : (valid ? true : null)" id="city" v-model="profile.city"
                            type="text"></b-form-input>
              <span class="er">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col md="4">
          <ValidationProvider rules="required" name="Land" v-slot="{valid, errors }">
            <b-form-group id="country-group">
              <label class="font-weight-500" for="country">Land<span style="color: red;">*</span></label>
              <b-form-input :state="errors[0] ? false : (valid ? true : null)" id="country" v-model="profile.country"
                            type="text"></b-form-input>
              <span class="er">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <ValidationProvider rules="required|iban" name="IBAN" v-slot="{valid, errors }">
            <b-form-group id="iban-group">
              <label class="font-weight-500" for="country">IBAN<span style="color: red;">*</span></label>
              <b-form-input  @input="ibanMask" @change="ibanMask" :state="errors[0] ? false : (valid ? true : null)" id="iban" v-model="profile.iban"
                            type="text"></b-form-input>
              <span class="er">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
      </b-row>
        <feature name="swissVatId">
          <b-row>
          <b-col md="6">
            <ValidationProvider rules="required" name="vatId" v-slot="{valid, errors }">
              <b-form-group id="vat-id">
                <label class="font-weight-500" for="vatId">Umsatzsteuer-ID<span style="color: red;">*</span></label>
                <b-form-input :state="errors[0] ? false : (valid ? true : null)" id="vatId" v-model="profile.vatId"
                              type="text"></b-form-input>
                <span class="er">{{ errors[0] }}</span>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          </b-row>
        </feature>
        <feature name="germanVatId">
          <b-row>
            <b-col md="6">
                <b-form-group id="vat-id">
                  <label class="font-weight-500" for="vatId">Steuernummer / Umsatzsteuer-ID</label>
                  <b-form-input id="vatId" v-model="profile.vatId"
                                type="text"></b-form-input>
                </b-form-group>
            </b-col>
          </b-row>
        </feature>
      <div class="text-left">
        <b-button type="submit" :disabled="!valid || !hasChange || inProgress">Speichern
          <b-spinner v-if="inProgress" small></b-spinner>
        </b-button>
      </div>
    </b-form>
  </ValidationObserver>
</template>
<script>
    import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
    import { required, email, regex, numeric } from 'vee-validate/dist/rules';
    import { FeatureToggleComponent as feature } from 'vue-feature-toggle';
    import { default as platformSettings } from '~config/settings';
    import { mapState } from "vuex";
    platformSettings.features.forEach(featureName => feature.visibility(featureName, true));

    extend('email', {
        ...email,
        message: 'Die E-Mailadresse ist nicht gültig'
    });
    extend('iban', {
        validate: value => {
            const v = value.replace(/ /g, '')
            if (v.length < 21) return false
            return regex.validate(v, {regex: /[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{7}([A-Z0-9]?){0,16}/})
        },
        message: "Das Format der IBAN ist nicht gültig"
    });
    extend('vatId', {
        validate: value => {
            return regex.validate(value, {regex: /CHE-\d{3}\.\d{3}\.\d{3}/})
        },
        message: "Umsatzsteuer-ID bitte im Format CHE-xxx.xxx.xxx eingeben"
    });
    extend('required', {
        ...required,
        message: 'Dieses Feld ist erforderlich'
    });
    extend('numeric', {
        ...numeric,
        message: 'Dieses Feld ist erforderlich'
    });

    export default {
        name: "InvoiceForm",
        computed: {
          ...mapState({
              currentProfile: state => state.user.profile
          })
        },
        data() {
            return {
                inProgress: false,
                hasChange: false,
                profile: {},
                values: {}

            }
        },
        components: {
            ValidationObserver,
            ValidationProvider,
            feature
        },
        watch: {
            currentProfile() {
                this.setCurrent()
            }
        },
        methods: {
            hasInput() {
              this.hasChange = !(JSON.stringify(this.profile) === JSON.stringify(this.values));
            },
            ibanMask() {
                this.profile.iban = this.profile.iban.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
            },
            setCurrent() {
                const form = this.$refs.form.querySelectorAll('input') || []
                const inputs = [...form]
                inputs.map(e => {
                    e.value = this.currentProfile[e.id] || ''
                    if (this.currentProfile[e.id]) {
                        this.profile[e.id] = this.currentProfile[e.id]
                        this.values[e.id] = this.currentProfile[e.id]
                    }
                })
            },
            async onSubmit() {
                this.inProgress = true
                this.$store.commit('user/setProfileUpdate', {...this.profile})
                try {
                    await this.$store.dispatch('user/saveProfile')
                } catch (error) {
                    console.log(error)
                    this.$bvModal.show('error-modal')
                    this.inProgress = false
                } finally {
                    this.inProgress = false
                    this.hasChange = false
                }
            }
        },
        mounted() {
          if (this.currentProfile) {
              this.setCurrent()
          }
        }
    }
</script>
